/*
    © 2022 BKThemes. All rights reserved.
    https://bkthemes.design
*/

// Init Wishlist
window.initWishlist = () => {
    const wishlist = JSON.parse(localStorage.getItem('eg_bigstore_wishlist')) || []

    document.querySelectorAll('.btn-atw').forEach((btn) => {
        const isWishlisted = wishlist.some((product) => product.id === btn.dataset.productId)

        if (isWishlisted) {
            btn.classList.add('active')
            btn.querySelector('span').textContent = btn.dataset.textRemoveFromWishlist
        } else {
            btn.classList.remove('active')
            btn.querySelector('span').textContent = btn.dataset.textAddToWishlist
        }
    })

    document.querySelectorAll('.wishlist-count-badge').forEach((el) => {
        if (wishlist.length === 0) {
            el.style.display = 'none'
        } else {
            el.style.display = 'block'
        }
    })
}
window.initWishlist()

// Handle Wishlist Button
window.onClickWishlistBtn = (btn, event) => {
    event.preventDefault()

    let wishlist = JSON.parse(localStorage.getItem('eg_bigstore_wishlist')) || []

    if (wishlist.some((product) => product.id === btn.dataset.productId)) {
        wishlist = wishlist.filter((product) => product.id !== btn.dataset.productId)
        btn.classList.remove('active')
    } else {
        wishlist.push({
            id: btn.dataset.productId,
            title: btn.dataset.productTitle,
            url: btn.dataset.productUrl,
            compare_at_price: btn.dataset.productCompareAtPrice,
            price: btn.dataset.productPrice,
            price_varies: btn.dataset.productPriceVaries,
            img_src: btn.dataset.productImgSrc,
            img_alt: btn.dataset.productImgAlt,
            wishlisted_at: Date.now()
        })
        btn.title = btn.dataset.textRemoveFromWishlist
        btn.classList.add('active')
    }
    localStorage.setItem('eg_bigstore_wishlist', JSON.stringify(wishlist))
    window.initWishlist()
}

// Load products in offcanvas wishlist
const initOffcanvasWishlist = () => {
    const offcanvas = document.querySelector('#wishlist-drawer')
    let wishlist = JSON.parse(localStorage.getItem('eg_bigstore_wishlist')) || []

    if (wishlist.length > 0) {
        let html = ''
        wishlist.forEach((product) => {
            html += `
                <li class="product-list-item">
                    <a href="${product.url}" class="row align-items-center mx-n3 py-3 text-decoration-none">
                        <div class="col-3 px-3">
                            <img 
                                class="product-img img-fluid ${offcanvas.dataset.imgBorder}"
                                src="${window.resizeImage(product.img_src || 'no-image.gif', `${offcanvas.dataset.imgWidth}x${offcanvas.dataset.imgHeight}`, 'center')}"
                                alt="${product.img_alt}" 
                                width="${offcanvas.dataset.imgWidth}"
                                height="${offcanvas.dataset.imgHeight}"
                                loading="lazy">
                        </div>
                        <div class="col-7 px-3">
                            <h5 class="product-title title h6 mb-2">
                                ${product.title}
                            </h5>
                            <p class="product-price-container text-body mb-1">
                                <s class="product-price-compare text-muted me-1 ${product.compare_at_price > product.price ? '' : 'd-none'}">
                                    <span class="visually-hidden">
                                        ${offcanvas.dataset.textOldPrice}
                                    </span>
                                    ${window.formatMoney(product.compare_at_price)}
                                </s>
                                <span class="product-price-final">
                                    <span class="price-from ${product.price_min !== product.price_max ? '' : 'd-none'}">
                                        ${offcanvas.dataset.textPriceFrom}
                                    </span>
                                    ${window.formatMoney(product.price)}
                                </span>
                            </p>
                        </div>
                        <div class="col-2 px-3">
                            <button 
                                class="offcanvas-wishlist-btn-remove btn btn-remove d-flex mx-auto text-muted"
                                aria-label="Remove"
                                data-product-id="${product.id}">
                                <svg 
                                    xmlns="http://www.w3.org/2000/svg" 
                                    width="20" 
                                    height="20" 
                                    fill="currentColor" 
                                    class="material-icon material-icon-remove" 
                                    viewBox="0 0 24 24">
                                    <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"></path>
                                </svg>
                            </button>
                        </div>
                    </a>
                </li>
            `
            offcanvas.querySelector('#drawer-wishlist-empty').style.display = 'none'
            offcanvas.querySelector('#wishlist-drawer .product-list').innerHTML = html
            offcanvas.querySelector('#wishlist-drawer .product-list').style.display = 'block'
        })
    } else {
        offcanvas.querySelector('#drawer-wishlist-empty').style.display = 'block'
        offcanvas.querySelector('#wishlist-drawer .product-list').style.display = 'none'
    }

    document.querySelectorAll('.offcanvas-wishlist-btn-remove:not(.init)').forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault()

            btn.classList.add('init')

            wishlist = wishlist.filter((product) => product.id !== btn.dataset.productId)
            localStorage.setItem('eg_bigstore_wishlist', JSON.stringify(wishlist))

            window.initWishlist()
            initOffcanvasWishlist()

            if (wishlist.length === 0) {
                setTimeout(() => {
                    const bsOffcanvas = bootstrap.Offcanvas.getInstance(document.querySelector('#wishlist-drawer'))
                    bsOffcanvas?.hide()
                }, 500)
            }
        })
    })
}

document.querySelector('#wishlist-drawer')?.addEventListener('show.bs.offcanvas', () => {
    initOffcanvasWishlist()
})
// Resize Shopify images - helper function
// https://gist.github.com/DanWebb/cce6ab34dd521fcac6ba
window.resizeImage = (src, size, crop = '') => src.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, '.')
    .replace(/\.jpg|\.png|\.gif|\.jpeg/g, (match) => {
        if (crop.length) {
            // eslint-disable-next-line no-param-reassign
            crop = `_crop_${crop}`
        }
        return `_${size}${crop}${match}`
    })
// Format money - helper function
// https://gist.github.com/stewartknapman/8d8733ea58d2314c373e94114472d44c
window.money_format = "${{amount}}";
window.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}